import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import { Link, generatePath } from 'react-router-dom';
import routes from 'globals/routes';

import './landingSection.css';
import './landingSectionMobile.css';

const LandingSection = ({content: pageContent}) => {
  // const  = props['content'];
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const logoUrl = content['logo'];
  return <section className="landing" id="landing">
    <div className="logo">
      <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
        <img src={logoUrl} />
      </Link>
    </div>
    <div className="contentWrapper">
      <div className="textContent">
        <div className="header" dangerouslySetInnerHTML={{
          __html: (pageContent['header'])
        }} />
        <div className="quote" dangerouslySetInnerHTML={{
          __html: (pageContent['quote'])
        }} />
        <div className="brief" dangerouslySetInnerHTML={{
          __html: (pageContent['brief'])
        }} />
        <div className="buttonWrapper">
          <div className="buttonDescription" dangerouslySetInnerHTML={{
            __html: (pageContent['buttondescription'])
          }} />
          {pageContent['buttonstatus'] == "1"?
            <a className={`button buttonType${pageContent['buttonstatus']}`} dangerouslySetInnerHTML={{
                __html: (pageContent['buttontext'])
              }}
              href={pageContent['buttonurl']}
              target="_blank"
            />:
            <div className={`button buttonType${pageContent['buttonstatus']}`} dangerouslySetInnerHTML={{
              __html: (pageContent['buttontext'])
            }} />
          }
        


        </div>
      </div>
      <div className="imageContent">
        <div className="imageWrapper">
          <img src={pageContent['mainImage']} />
          <div className="verticalText" dangerouslySetInnerHTML={{
            __html: pageContent['month'][0]
          }} />
        </div>
      </div>
    </div>
    <div className="decorateLine" />
    <div className="scrollHints" dangerouslySetInnerHTML={{
      __html: pageContent['scrollHints']
    }} />
  </section>;
}

export default LandingSection;